import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { rolesAndPromissionAPI } from '@/providers/apis/roles-and-permission/roles-and-permission';
import { sessionService } from '@/providers/services/auth/session';
import { RoleModel, TenantUsersList } from '@/models/role-permission/role-permission';
import axios from 'axios';
import { USER_LIST_SETTINGS } from '@/utils/constants';

@Component({
    name: 'user-list',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class UserList extends Vue {

    // -------------------------------------------------------------------
    // Properties

    private get session() {
        return sessionService.getSession();
    }

    private usersList: TenantUsersList[] = [];

    private userFileds: any = USER_LIST_SETTINGS;

    private roleList: RoleModel[] = [];

    private searchText: any = '';

    private isLoading: boolean = false;

    private get filteredUserList() {
        return this.usersList.filter((item: any) => {
            return item.firstName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 ||
            item.lastName.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1 ||
            item.email.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1;
        });
    }

    // -------------------------------------------------------------------
    // Actions

    public onSwitchComponent(key: string, userData: TenantUsersList) {
        this.$emit('onSwitchComponent', key, userData);
    }

    public onSelectRow(item: any) {
        this.onSwitchComponent('add-user', item);
    }


    // -------------------------------------------------------------------
    // Hooks

    private created() {
        this.loadUsersList();
    }

    // --------------------------------------------------------------------
    // Methods

    private loadUsersList() {
        const that = this;
        that.isLoading = true;
        const tenantId = this.session!.tenant!.tenant_id || '';
        this.roleList = this.$store.state.rosterStore.rolesList;
        if (this.roleList.length === 0) {
            setTimeout(() => {
                that.loadUsersList();
            }, 1000);
        }
        if (this.roleList.length > 0) {
            const promiseList: any = [
                rolesAndPromissionAPI.fetchSettingsUserList(),
            ];
            axios.all(promiseList).then(axios.spread((userList: any) => {
                for (const iteratorUser of userList) {
                    for (const iterator of iteratorUser.roles) {
                        const role = this.roleList.find((item: RoleModel) => item.id === iterator);
                        if (role && role.displayName) {
                            iteratorUser.rolesName.push(role.displayName);
                        }
                    }
                }
                that.isLoading = false;
                this.usersList = userList;
            }));
        }
    }


}
